import React from "react";
import { motion } from "framer-motion";

// When the page was prerendered (window.__PRERENDERED__), motion components
// must START at their target state — otherwise framer-motion would mount in
// the `initial` (hidden / translated) state which disagrees with the
// already-painted prerendered DOM, producing a hydration mismatch and a
// visible flash before animations resolve.
const initialState = (def) => {
  if (typeof window !== "undefined" && window.__PRERENDERED__) return false;
  return def;
};

export function Reveal({ children, delay = 0, y = 14, className = "" }) {
  return (
    <motion.div
      initial={initialState({ opacity: 0, y })}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.55, ease: [0.22, 0.6, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Stagger({ children, className = "", delay = 0.06 }) {
  return (
    <motion.div
      initial={initialState("hidden")}
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: delay } },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export const Item = ({ children, className = "" }) => (
  <motion.div
    initial={initialState(undefined)}
    variants={{
      hidden: { opacity: 0, y: 16 },
      show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 0.6, 0.36, 1] } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);
